import React from 'react';

const App = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('e');
  if(id !== undefined && id !== ""){
    window.location.href = "https://miracledome.page.link/?link=https%3A%2F%2Fweb.icsi.lk%2Fpark-app%3Fstation-id%3D" + id + "&apn=com.ceyentra.miracledome&ibi=com.ceyentra.miracledome";
  }else{
    window.location.replace(window.location.origin);
  }
};
export default App;
